"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PiniaFirestoreSync = void 0;
var firestore_1 = require("firebase/firestore");
/**
 * Adds a `sync` function to your store.
 * The `sync` method can sync your state propery with firestore  Document/Collection/Query easily.
 *
 * @example
 *
 * ```ts
 * import { PiniaFirestoreSync } from 'pinia-plugin-firestore-sync'
 * ...
 * const pinia = createPinia().use(firestoreSyncPlugin)
 * app.use(pinia).mount('#app')
 *
 * ```
 */
var PiniaFirestoreSync = function (_a) {
    var store = _a.store;
    store.sync = function (key, ref) {
        // Document
        if (ref instanceof firestore_1.DocumentReference) {
            return (0, firestore_1.onSnapshot)(ref, function (ds) {
                var _a;
                if (ds.exists()) {
                    store.$patch((_a = {}, _a[key] = ds.data(), _a));
                }
            });
        }
        // Collection or Query
        return (0, firestore_1.onSnapshot)(ref, function (qs) {
            var datum = qs.docs.map(function (d) { return d.data(); });
            store.$patch(function (state) {
                state[key] = datum;
            });
        });
    };
};
exports.PiniaFirestoreSync = PiniaFirestoreSync;
